import { call, put, takeEvery } from 'redux-saga/effects';
import { _BROTHER_PLUS_API_ENDPOINTS, SUCCESS } from '../../../constants/AppConstants';
import { _CALLGETAPI } from '../../../api/apiHandler';
import i18next from 'i18next';
import {
  getNewDevicePromoCodeFailure,
  getNewDevicePromoCodeRequest,
  getNewDevicePromoCodeSuccess
} from './getNewDevicePromoCodeSlice';

function _GETNEWDEVICEPROMOCODE(userId, deviceId) {
  const endpoint = _BROTHER_PLUS_API_ENDPOINTS.GET_NEW_DEVICE_PROMO_CODE;
  const payload = {
    params: {
      userId,
      deviceId
    }
  };

  return _CALLGETAPI(endpoint, payload)
    .then(response => response)
    .catch(error => {
      throw error;
    });
}

function* getNewDevicePromoCodeSaga(action) {
  try {
    const { userId, deviceId } = action.payload;

    const newDevicePromoCode = yield call(
      _GETNEWDEVICEPROMOCODE,
      userId,
      deviceId
    );

    if (newDevicePromoCode?.actionStatus?.toUpperCase() === SUCCESS) {
      yield put(getNewDevicePromoCodeSuccess(newDevicePromoCode));
    } else {
      yield put(
        getNewDevicePromoCodeFailure(
          i18next.t('ERROR_CONTENT.ERR_INFO.TECHNICAL_ERROR')
        )
      );
    }
  } catch (error) {
    yield put(getNewDevicePromoCodeFailure(error.message));
  }
}

export default function* watchGetNewDevicePromoCodeService() {
  yield takeEvery(
    getNewDevicePromoCodeRequest.type,
    getNewDevicePromoCodeSaga
  );
}
